import { Routes } from '@angular/router';
import { LoginPage, MainPage } from '../pages';


export const PUBLIC_ROUTES: Routes = [
  { path: 'main',      component: MainPage },  
  { path: 'login',      component: LoginPage },  
];